import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // Override the default secondary button (orange-on-orange against the
  // banner's orange_75 background would be near-invisible) — solid dark green
  // gives strong contrast and matches the `transfer-to-agency-notification`
  // CTA pattern.
  endButton: {
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white,
    fontSize: 16
  }
});

export default makeStyles(styles);
